import { useQuery } from 'react-query';

import { getDataStory as queryFn } from 'api/endPoints/getDataStory';
import { QueryResponse } from 'api/queries/getDataStories.query';

export const useQueryExpandStory = (params) => {
    return useQuery<QueryResponse, QueryError>(['expandStory', params], () => queryFn(params), {
        enabled: Boolean(params),
        placeholderData: {
            tags: [],
            dataStory: [],
            startDate: 0,
            endDate: 0,
            token: '',
        },
    });
};
